import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Package, Users, FileText, LogOut, Menu, X, RotateCcw, Search } from "lucide-react";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, tid: "nav-dashboard" },
  { to: "/products", label: "Products", icon: Package, tid: "nav-products" },
  { to: "/customers", label: "Customers", icon: Users, tid: "nav-customers" },
  { to: "/invoices", label: "Invoices", icon: FileText, tid: "nav-invoices" },
  { to: "/returns", label: "Returns", icon: RotateCcw, tid: "nav-returns" },
  { to: "/reports/style-sales", label: "Style Sales", icon: Search, tid: "nav-style-sales" },
];

export default function Shell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); nav("/login"); };

  return (
    <div className="app-shell">
      <div className="topbar">
        <h1>Garment ERP</h1>
        <button data-testid="mobile-menu-toggle" className="btn btn-ghost" onClick={() => setOpen(!open)} style={{ color: "white" }}>
          {open ? <X size={18}/> : <Menu size={18}/>}
        </button>
      </div>
      <aside className={`sidebar ${open ? "open" : ""}`} data-testid="app-sidebar">
        <div className="sidebar-brand">
          <h1>Garment ERP</h1>
          <p>Inventory & Invoicing</p>
        </div>
        <nav className="sidebar-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.tid} onClick={() => setOpen(false)}>
              <l.icon size={16}/><span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div style={{ color: "#CBD5E1", marginBottom: 4 }}>{user?.email}</div>
          <button data-testid="logout-button" onClick={doLogout}><LogOut size={12} style={{verticalAlign:"middle", marginRight:6}}/>Logout</button>
        </div>
      </aside>
      <main className="content">{children}</main>
    </div>
  );
}
